var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19375_34990",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19375_34990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9244 37.1244L35.9994 34.7994L39.0744 37.1244C39.5744 37.4744 40.0619 37.4869 40.5369 37.1619C41.0119 36.8369 41.1494 36.3994 40.9494 35.8494L39.7494 31.9494L42.5994 29.9244C43.0994 29.5744 43.2494 29.1244 43.0494 28.5744C42.8494 28.0244 42.4744 27.7494 41.9244 27.7494H38.2494L37.1244 23.9994C36.9244 23.4494 36.5494 23.1744 35.9994 23.1744C35.4494 23.1744 35.0744 23.4494 34.8744 23.9994L33.7494 27.7494H30.0744C29.5244 27.7494 29.1494 28.0244 28.9494 28.5744C28.7494 29.1244 28.8994 29.5744 29.3994 29.9244L32.2494 31.9494L31.0494 35.8494C30.8494 36.3994 30.9869 36.8369 31.4619 37.1619C31.9369 37.4869 32.4244 37.4744 32.9244 37.1244ZM24.7494 62.1744C24.0494 62.4244 23.3994 62.3119 22.7994 61.8369C22.1994 61.3619 21.8994 60.7494 21.8994 59.9994V44.2494C19.9994 42.4494 18.5244 40.3244 17.4744 37.8744C16.4244 35.4244 15.8994 32.7994 15.8994 29.9994C15.8994 24.3994 17.8494 19.6494 21.7494 15.7494C25.6494 11.8494 30.3994 9.89941 35.9994 9.89941C41.5994 9.89941 46.3494 11.8494 50.2494 15.7494C54.1494 19.6494 56.0994 24.3994 56.0994 29.9994C56.0994 32.7994 55.5744 35.4244 54.5244 37.8744C53.4744 40.3244 51.9994 42.4494 50.0994 44.2494V59.9994C50.0994 60.7494 49.7994 61.3619 49.1994 61.8369C48.5994 62.3119 47.9494 62.4244 47.2494 62.1744L35.9994 58.9494L24.7494 62.1744ZM35.9994 47.9994C40.9994 47.9994 45.2494 46.2494 48.7494 42.7494C52.2494 39.2494 53.9994 34.9994 53.9994 29.9994C53.9994 24.9994 52.2494 20.7494 48.7494 17.2494C45.2494 13.7494 40.9994 11.9994 35.9994 11.9994C30.9994 11.9994 26.7494 13.7494 23.2494 17.2494C19.7494 20.7494 17.9994 24.9994 17.9994 29.9994C17.9994 34.9994 19.7494 39.2494 23.2494 42.7494C26.7494 46.2494 30.9994 47.9994 35.9994 47.9994ZM23.9994 60.1494L35.9994 56.6994L47.9994 60.1494V46.0494C46.3494 47.3494 44.4994 48.3494 42.4494 49.0494C40.3994 49.7494 38.2494 50.0994 35.9994 50.0994C33.7494 50.0994 31.5994 49.7494 29.5494 49.0494C27.4994 48.3494 25.6494 47.3494 23.9994 46.0494V60.1494Z",
    fill: "#00B0CA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/Badge.e4f8f8103161233edea312147afb793a.svg";
export { ForwardRef as ReactComponent };